
// 事件管理器
export class MEventManager {
    _events: any;
    constructor() {
        this._events = {}
    }

    add(id: string, data: any) {
        this._events[id] = this._events[id] || []
        this._events[id].push(data)
    }

    get(id: string) {
        return this._events[id];
    }

    remove(id: string) {
        this._events[id] = null
    }

    clear() {
        this._events = {}
    }
}

